module.exports = __webpack_public_path__ + "static/media/fleche-lire-plus.c89fcb7c.svg";